import React from "react";
import styled from "styled-components";
import { Link, useLocation } from "react-router-dom";

const Header = ({ toggleMenu }) => {
  const location = useLocation();
  const isActive = (path) => {
    if (path === "/") {
      return location.pathname === "/";
    }
    return location.pathname.startsWith(path);
  };

  return (
    <Wrapper>
      <header className="th-header header-layout12 onepage-nav">
        <div className="header-top">
          <div className="container">
            <div className="row gx-0 justify-content-center justify-content-md-between align-items-center">
              <div className="col-auto">
                <div className="top-left">
                  <p className="header-notice">Al Jurf Pest Control LLC</p>
                </div>
              </div>

              <div className="col-auto d-none d-md-block">
                <div className="top-right">
                  <div className="row gx-0 align-items-center justify-content-between">
                    <div className="col-auto">
                      <div className="header-links">
                        <ul>
                          <li className="d-none d-lg-inline-block">
                            <i className="fal fa-phone"></i>
                            <Link to="tel:056 118 4114">056 118 4114</Link>
                          </li>

                          <li className="d-none d-xxl-inline-block">
                            <i className="fal fa-location-dot"></i>Deira, Naif,
                            Dubai-UAE.
                          </li>

                          <li>
                            <i className="fal fa-envelope"></i>
                            <Link to="mailto:info@aljurfpestcontrol.ae">
                              info@aljurfpestcontrol.ae
                            </Link>
                          </li>
                        </ul>
                      </div>
                    </div>

                    <div className="col-auto">
                      <div className="header-social">
                        <Link
                          target="_blank"
                          to="https://www.facebook.com/share/17wS89FDNB/"
                        >
                          <i className="fab fa-facebook-f"></i>
                        </Link>

                        <Link to="https://www.youtube.com/">
                          <i className="fab fa-youtube"></i>
                        </Link>

                        <Link to="https://www.instagram.com/">
                          <i className="fab fa-instagram"></i>
                        </Link>

                        <Link to="https://www.twitter.com/">
                          <i className="fab fa-tiktok"></i>
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="sticky-wrapper">
          <div className="sticky-active">
            <div className="container">
              <div className="row gx-0 justify-content-between">
                <div className="col-auto">
                  <div className="header-logo">
                    <Link to="/">
                      <img
                        src="/assets/image/Logo.png"
                        alt="logo img"
                        style={{ width: "170px", height: "66px" }}
                      />
                    </Link>
                  </div>
                </div>

                <div className="col-auto">
                  <div className="menu-area">
                    <div className="row gx-0 align-items-center justify-content-between">
                      <div className="col-auto">
                        <nav className="main-menu d-none d-lg-inline-block">
                          <ul>
                            <li className={isActive("/") ? "active" : ""}>
                              <Link to="/">Home</Link>
                            </li>

                            <li className={isActive("/about") ? "active" : ""}>
                              <Link to="/about">About</Link>
                            </li>

                            <li
                              className={isActive("/service") ? "active" : ""}
                            >
                              <Link to="/service">Service</Link>
                            </li>

                            <li
                              className={isActive("/project") ? "active" : ""}
                            >
                              <Link to="/project">Project</Link>
                            </li>

                            <li
                              className={isActive("/gallery") ? "active" : ""}
                            >
                              <Link to="/gallery">Gallery</Link>
                            </li>

                            <li className={isActive("/blog") ? "active" : ""}>
                              <Link to="/blog">Blog</Link>
                            </li>

                            <li
                              className={isActive("/contact") ? "active" : ""}
                            >
                              <Link to="/contact">Contact</Link>
                            </li>
                          </ul>
                        </nav>

                        <button
                          onClick={toggleMenu}
                          type="button"
                          className="th-menu-toggle d-inline-block d-lg-none"
                        >
                          <i className="far fa-bars"></i>
                        </button>
                      </div>

                      <div className="col-auto d-none d-xxl-block">
                        <div className="header-button">
                          {/* WhatsApp Button */}
                          <Link
                            to="https://wa.me/971561184114" // Replace with your WhatsApp number
                            target="_blank"
                            rel="noopener noreferrer"
                            className="icon-btn style2"
                          >
                            <i className="fab fa-whatsapp"></i>
                          </Link>

                          {/* Call Button */}
                          <Link to="tel:0561184114" className="icon-btn style2">
                            <i className="fas fa-phone"></i>
                          </Link>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>
    </Wrapper>
  );
};

const Wrapper = styled.section`
  .no-border {
    border: none !important;
    outline: none !important;
    box-shadow: none !important;
    text-decoration: none !important;
  }

  .main-menu ul li a {
    text-decoration: none;
    color: white;
  }

  .main-menu ul li.active a {
    color: #ff5e14 !important;
  }

  @media (max-width: 1024px) {
    .main-menu a {
      font-size: 10px !important;
    }
  }
`;

export default Header;
